module.exports = __webpack_public_path__ + "assets/img/6037df634bccf08cf471c5f6ab18430f.svg";